import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Link } from "react-router-dom";
import VVVPrimaryButton from "../design-system/vvv/Button";

export default function Distribution() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className="py-12 h-full relative overflow-hidden 4xl:max-w-[100rem] 4xl:mx-auto"
    >
      <div className="flex flex-col items-center justify-center gap-10 lg:gap-20">
        <div className="flex flex-col items-center justify-center text-center gap-10">
          <div className="space-y-2">
            <p className="text-white/50">Video Distribution</p>
            <h1
              className={`vvv-font text-4xl lg:text-5xl max-w-sm md:max-w-lg lg:max-w-4xl ${isVisible ? "zoom-in" : "opacity-0 scale-90"}`}
              style={{ lineHeight: 1.2 }}
            >
              Use the Internet’s{" "}
              <span className="text-primary">best clips</span> in your next{" "}
              <span className="text-primary">YouTube</span> video
            </h1>
          </div>
          <p
            className={`text-white max-w-xs lg:max-w-full ${isVisible ? "zoom-in-delay" : "opacity-0 scale-90"}`}
          >
            Take the fast track to going viral with our epic clips.
          </p>
          <Link to="/contact-us">
            <VVVPrimaryButton
              name="Request Access"
              className={`${isVisible ? "zoom-in-late" : "opacity-0 scale-90"}`}
            />
          </Link>
        </div>
        <div className="w-full flex flex-col lg:flex-row items-center justify-between relative">
          <div className="w-full lg:w-fit xl:-mt-28 hidden lg:block lg:space-y-1 xl:space-y-0">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-partner-revenue-left.svg"
              className="lg:max-w-[210px] xl:max-w-[350px] 1xl:max-w-[400px] card-entry"
              alt="Revenue Card"
            />
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-distribution-earnings-left.svg"
              className="lg:max-w-[210px] xl:max-w-[350px] 1xl:max-w-[400px] card-entry -mt-8"
              alt="Revenue Card"
            />
          </div>
          <div className="w-full flex items-center justify-between lg:hidden">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-partner-revenue-left.svg"
              className="max-w-[180px] xs:max-w-[190px] md:max-w-[400px]"
              alt="Revenue Card"
            />
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-partner-revenue-top-right.svg"
              className="max-w-[180px] xs:max-w-[190px] md:max-w-[400px]"
              alt="Revenue Card"
            />
          </div>
          <div className="lg:absolute lg:left-1/2 lg:-translate-x-1/2">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/subscribers.svg"
              className="lg:max-w-[620px] xl:min-w-[500px] 1xl:min-w-[650px] 2xl:min-w-[720px] card-entry"
              alt="Revenue Card"
            />
          </div>
          <div className="w-full lg:w-fit xl:-mt-28 hidden lg:block lg:space-y-1 xl:space-y-0">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-partner-revenue-top-right.svg"
              className="lg:max-w-[210px] xl:max-w-[350px] 1xl:max-w-[400px] card-entry"
              alt="Revenue Card"
            />
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-partner-revenue-bottom-right.svg"
              className="lg:max-w-[210px] xl:max-w-[350px] 1xl:max-w-[400px] card-entry -mt-8"
              alt="Revenue Card"
            />
          </div>
          <div className="w-full flex items-center justify-between lg:hidden">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-distribution-earnings-left.svg"
              className="max-w-[180px] xs:max-w-[190px] md:max-w-[400px]"
              alt="Revenue Card"
            />
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/estimated-partner-revenue-bottom-right.svg"
              className="max-w-[180px] xs:max-w-[190px] md:max-w-[400px]"
              alt="Revenue Card"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
